const HERO_IMAGE =
    "https://customer-assets.emergentagent.com/job_a4c9c179-d042-4742-b732-bd5e37197666/artifacts/sw53cej4_Image%206.jpeg";

/**
 * Link-preview (Open Graph) image at /og — 1200×630.
 * Captured by scripts/build_og_image.py.
 */
export const OgExport = () => (
    <div
        data-export-root="true"
        style={{
            width: 1200,
            height: 630,
            position: "relative",
            overflow: "hidden",
            background: "#050C08",
            color: "#F7F9F5",
            fontFamily: "'Cabinet Grotesk', 'Manrope', system-ui, sans-serif",
        }}
    >
        <img
            src={HERO_IMAGE}
            alt=""
            style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
            }}
        />
        <div
            style={{
                position: "absolute",
                inset: 0,
                background:
                    "linear-gradient(to right, rgba(5,12,8,0.96), rgba(5,12,8,0.72) 50%, rgba(5,12,8,0.25))",
            }}
        />
        <div
            style={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                height: "60%",
                background:
                    "linear-gradient(to top, rgba(5,12,8,0.9), transparent)",
            }}
        />

        <img
            src="/bushel-wordmark-lime.png"
            alt="Bushel"
            style={{
                position: "absolute",
                top: 56,
                left: 72,
                height: 64,
                width: "auto",
            }}
        />

        <div style={{ position: "absolute", left: 72, bottom: 64, maxWidth: 900 }}>
            <p
                style={{
                    margin: 0,
                    fontSize: 15,
                    fontWeight: 500,
                    letterSpacing: "0.34em",
                    textTransform: "uppercase",
                    color: "#89F337",
                }}
            >
                Coming Soon 2026 · Strathroy, Ontario
            </p>
            <h1
                style={{
                    margin: "18px 0 0",
                    fontSize: 84,
                    fontWeight: 800,
                    lineHeight: 1.0,
                    letterSpacing: "-0.015em",
                }}
            >
                Grown{" "}
                <span style={{ fontWeight: 500, color: "#89F337" }}>clean.</span>
                <br />
                Grown local. Year round.
            </h1>
            <p
                style={{
                    margin: "22px 0 0",
                    fontSize: 24,
                    lineHeight: 1.4,
                    color: "#C9D3CC",
                    maxWidth: 820,
                }}
            >
                Beyond organic. Pesticide, herbicide and fungicide-free leafy
                greens from an advanced indoor vertical farm.
            </p>
        </div>
    </div>
);
